
  <mat-dialog-content>
    <div class="header">
      <div class="title">{{ data.title || '担当選択' }}</div>
    </div>

      <div
      class="notice-area"
      [class.personal-setting]="data?.title"
      >

        <div class="notice-content">
          <div class="notice-title">＜所属・担当・対象について＞</div>
          <div class="notice-text">
            対象範囲は1つの階層だけ選択してください。ブロック全体ならブロックのみ、職場単位なら職場のみを選択してください。<br>
            ※例：営業ブロックを担当する支部執行委員の方などの場合は「営業ブロック」のみを選択します。<br>
          </div>
          <div class="notice-text indent">（上位の支部名や、営業ブロックに紐づく職場名は選択不要）</div>
        </div>

        @if (showClearAll) {
          <div class="notice-action">
            <button class="clear-all-btn" (click)="onClearAll($event)">
              すべて解除
            </button>
          </div>
        }

      </div>


  <div class="content">
    @if (showSpinner) {
      <div class="spinner center">
        <mat-spinner></mat-spinner>
      </div>
    } @else {
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" [trackBy]="trackByFn">

        <!-- leaf -->
        <mat-tree-node *matTreeNodeDef="let node; let level = level">
          <ng-container *ngIf="!node.skip">

            <div class="node-row nochild" [class.no-children]="!node.children || node.children.length === 0" matTreeNodePadding [style.--level]="getLevel(node)" [matTreeNodePaddingIndent]="160">

              <mat-checkbox class="thin-checkbox" [checked]="node.checked" [disabled]="isAllSelected && node.id !== ZENBU_ID" (change)="toggleNode(node, $event.checked)"></mat-checkbox>

              <span class="node-name" [class.disabled-node]="isAllSelected && node.id !== ZENBU_ID" (click)="(isAllSelected && node.id !== ZENBU_ID) ? null : toggleNode(node, !node.checked)">{{node.name }}</span>

              <!-- 透明toggle -->
              <button
              mat-icon-button
              class="toggle-placeholder"
              disabled
            >
              <mat-icon>chevron_right</mat-icon>
            </button>

            </div>

          </ng-container>

        </mat-tree-node>


        <!-- expandable -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild; let level = level">
          <ng-container *ngIf="!node.skip">

            <div class="node-row" matTreeNodePadding [style.--level]="getLevel(node)" [matTreeNodePaddingIndent]="160">

              <mat-checkbox class="thin-checkbox" [checked]="node.checked" [disabled]="isAllSelected && node.id !== ZENBU_ID" (change)="toggleNode(node, $event.checked)"></mat-checkbox>

              <span class="node-name" [class.disabled-node]="isAllSelected && node.id !== ZENBU_ID" (click)="(isAllSelected && node.id !== ZENBU_ID) ? null : toggleNode(node, !node.checked)">{{node.name }}</span>

              <div class="toggle-area" matTreeNodeToggle>
                <button mat-icon-button matTreeNodeToggle class="toggle-btn">
                  <mat-icon class="icon">
                    {{ treeControl.isExpanded(node) ? 'expand_less' : 'expand_more' }}
                  </mat-icon>
                </button>
              </div>

            </div>

          </ng-container>

          <div [class.hidden]="!treeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </div>

        </mat-nested-tree-node>

      </mat-tree>
}
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (isSaving) {
    <mat-spinner diameter="28" class="spinner"></mat-spinner>
  }
  <button mat-raised-button mat-dialog-close>キャンセル</button>
  <button mat-raised-button (click)="onSave()" [disabled]="isSaving || showSpinner" class="yes-btn">選択</button>
</mat-dialog-actions>
